export function setShowPreview(showPreview) {
    return {type: SET_SHOW_PREVIEW, showPreview};
}
export const SET_SHOW_PREVIEW = 'SET_SHOW_PREVIEW';
